import axios from "axios";
import { VENDORS_STATE_URL, VENDORS_URL } from "../../API/Api";

const GetAllVendors = async (token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        baseURL: `${VENDORS_URL}`,
        headers:headers,
    });
    return response.data;
};

const GetSingleVendor = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const response = await axios({
        method: "GET",
        baseURL: `${VENDORS_URL}/${id}`,
        headers:headers,
    });
    return response.data;
};

const CerateNewVendor = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const response = await axios({
        method: "POST",
        baseURL: `${VENDORS_URL}/create`,
        headers:headers,
        data: data,
    });
    return response.data;
};

const UpdateVendorData = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const response = await axios({
        method: "POST",
        baseURL: `${VENDORS_URL}/update/${data.id}`,
        headers:headers,
        data: data,
    });
    return response.data;
};
const DeleteVendorAction = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const response = await axios({
        method: "GET",
        baseURL: `${VENDORS_URL}/delete/${id}`,
        headers:headers,
    });
    return response.data;
};

const DeleteStateAction = async (state_id, token) => {
    let headers = {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
    }

    let response = axios({
        method: "GET",
        baseURL: `${VENDORS_STATE_URL}/delete/${state_id}`,
        headers:headers,
    });

    return response.data
}


const VendorsService = {
    GetAllVendors,
    CerateNewVendor,
    DeleteVendorAction,
    GetSingleVendor,
    DeleteStateAction,
    UpdateVendorData
};

export default VendorsService;
